var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useRef, useEffect } from 'react';
import { X, Upload, Loader2, CheckCircle, AlertCircle, MessageCircle } from 'lucide-react';
import { createPortal } from 'react-dom';
import { createFeedback } from '../../actions/feedbacks';
import { showToast } from '../../utils/toastUtils';
var FEEDBACK_TYPES = [
    { value: 'bug', label: '🐛 Bug Report', color: 'text-red-400' },
    { value: 'suggestion', label: '💡 Sugestão', color: 'text-blue-400' },
    { value: 'question', label: '❓ Dúvida', color: 'text-yellow-400' },
    { value: 'problem', label: '⚠️ Problema', color: 'text-orange-400' },
    { value: 'praise', label: '❤️ Elogio', color: 'text-pink-400' },
    { value: 'request', label: '📊 Solicitação', color: 'text-purple-400' },
];
var FeedbackModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var _b = useState('bug'), type = _b[0], setType = _b[1];
    var _c = useState(''), title = _c[0], setTitle = _c[1];
    var _d = useState(''), description = _d[0], setDescription = _d[1];
    var _e = useState(null), screenshot = _e[0], setScreenshot = _e[1];
    var _f = useState(null), screenshotPreview = _f[0], setScreenshotPreview = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var fileInputRef = useRef(null);
    // ✅ Previne scroll do body quando modal estiver aberto
    useEffect(function () {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
        return function () {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);
    // Reset form quando fechar
    useEffect(function () {
        if (!isOpen) {
            setTimeout(function () {
                setType('bug');
                setTitle('');
                setDescription('');
                setScreenshot(null);
                setScreenshotPreview(null);
            }, 300);
        }
    }, [isOpen]);
    var handleFileChange = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            // Valida tamanho (5MB)
            if (file.size > 5 * 1024 * 1024) {
                showToast('error', 'Imagem muito grande (máximo 5MB)');
                return;
            }
            // Valida tipo
            if (!file.type.startsWith('image/')) {
                showToast('error', 'Apenas imagens são aceitas');
                return;
            }
            setScreenshot(file);
            // Gera preview
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                setScreenshotPreview(reader_1.result);
            };
            reader_1.readAsDataURL(file);
        }
    };
    var handleRemoveScreenshot = function () {
        setScreenshot(null);
        setScreenshotPreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var userAgent, screenResolution, pageUrl, pageName, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    if (!title.trim() || !description.trim()) {
                        showToast('error', 'Preencha título e descrição');
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    userAgent = navigator.userAgent;
                    screenResolution = "".concat(window.screen.width, "x").concat(window.screen.height);
                    pageUrl = window.location.href;
                    pageName = document.title || 'Página sem título';
                    return [4 /*yield*/, createFeedback({
                            type: type,
                            title: title.trim(),
                            description: description.trim(),
                            page_url: pageUrl,
                            page_name: pageName,
                            user_agent: userAgent,
                            screen_resolution: screenResolution,
                            screenshot_file: screenshot || undefined,
                        })];
                case 2:
                    _c.sent();
                    showToast('success', '✅ Feedback enviado com sucesso! Obrigado!');
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.error('Erro ao enviar feedback:', error_1);
                    showToast('error', ((_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || 'Erro ao enviar feedback');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // ✅ Fecha modal ao clicar no backdrop
    var handleBackdropClick = function (e) {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };
    if (!isOpen)
        return null;
    var suggestedPriority = type === 'bug' || type === 'problem' ? 'Alta' : type === 'request' ? 'Média' : 'Baixa';
    // ✅ Renderiza como portal no body (não afetado por z-index de outros modais)
    return createPortal(React.createElement("div", { className: "fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fadeIn", onClick: handleBackdropClick },
        React.createElement("div", { className: "bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-gray-700 animate-slideUp" },
            React.createElement("div", { className: "sticky top-0 bg-gray-900/95 backdrop-blur-sm px-6 py-4 flex items-center justify-between border-b border-gray-700 z-10" },
                React.createElement("h2", { className: "text-2xl font-bold text-white flex items-center gap-2" },
                    React.createElement(MessageCircle, { size: 24, className: "text-green-400" }),
                    "Envie seu Feedback"),
                React.createElement("button", { onClick: onClose, className: "text-gray-400 hover:text-white transition p-2 hover:bg-gray-800 rounded-lg", disabled: loading },
                    React.createElement(X, { size: 24 }))),
            React.createElement("form", { onSubmit: handleSubmit, className: "p-6 space-y-5" },
                React.createElement("div", null,
                    React.createElement("label", { className: "block text-sm font-semibold text-gray-300 mb-2" }, "\uD83D\uDCCC Tipo de Feedback"),
                    React.createElement("select", { value: type, onChange: function (e) { return setType(e.target.value); }, className: "w-full bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition", disabled: loading }, FEEDBACK_TYPES.map(function (t) { return (React.createElement("option", { key: t.value, value: t.value }, t.label)); }))),
                React.createElement("div", null,
                    React.createElement("label", { className: "block text-sm font-semibold text-gray-300 mb-2" }, "\uD83D\uDCDD T\u00EDtulo"),
                    React.createElement("input", { type: "text", value: title, onChange: function (e) { return setTitle(e.target.value); }, placeholder: "Digite um t\u00EDtulo curto e descritivo...", maxLength: 100, className: "w-full bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition", disabled: loading, required: true }),
                    React.createElement("span", { className: "text-xs text-gray-400 mt-1 block" },
                        title.length,
                        "/100 caracteres")),
                React.createElement("div", null,
                    React.createElement("label", { className: "block text-sm font-semibold text-gray-300 mb-2" }, "\u270D\uFE0F Descri\u00E7\u00E3o"),
                    React.createElement("textarea", { value: description, onChange: function (e) { return setDescription(e.target.value); }, placeholder: "Descreva detalhadamente o que aconteceu, o que voc\u00EA esperava, passos para reproduzir, etc...", rows: 6, className: "w-full bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition resize-none", disabled: loading, required: true })),
                React.createElement("div", null,
                    React.createElement("label", { className: "block text-sm font-semibold text-gray-300 mb-2" }, "\uD83D\uDCF8 Anexar Screenshot (opcional)"),
                    !screenshotPreview ? (React.createElement("label", { className: "flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-600 rounded-lg cursor-pointer hover:border-blue-400 hover:bg-gray-700/50 transition" },
                        React.createElement("div", { className: "flex flex-col items-center gap-2" },
                            React.createElement(Upload, { size: 32, className: "text-gray-400" }),
                            React.createElement("span", { className: "text-sm text-gray-400" }, "Clique ou arraste uma imagem aqui"),
                            React.createElement("span", { className: "text-xs text-gray-500" }, "PNG, JPG, GIF - M\u00E1x 5MB")),
                        React.createElement("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleFileChange, className: "hidden", disabled: loading }))) : (React.createElement("div", { className: "relative" },
                        React.createElement("img", { src: screenshotPreview, alt: "Preview", className: "w-full h-auto max-h-64 object-contain rounded-lg border border-gray-600" }),
                        React.createElement("button", { type: "button", onClick: handleRemoveScreenshot, className: "absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white p-2 rounded-lg transition", disabled: loading },
                            React.createElement(X, { size: 16 }))))),
                React.createElement("div", { className: "bg-blue-500/10 border border-blue-500/30 rounded-lg p-4" },
                    React.createElement("p", { className: "text-sm text-blue-300 font-semibold mb-2" }, "\u2139\uFE0F Informa\u00E7\u00F5es capturadas automaticamente:"),
                    React.createElement("ul", { className: "text-xs text-blue-200 space-y-1" },
                        React.createElement("li", null,
                            "\u2022 P\u00E1gina: ",
                            document.title || window.location.pathname),
                        React.createElement("li", null,
                            "\u2022 Navegador: ",
                            navigator.userAgent.split(' ').slice(-2).join(' ')),
                        React.createElement("li", null,
                            "\u2022 Resolu\u00E7\u00E3o: ",
                            window.screen.width,
                            "x",
                            window.screen.height))),
                React.createElement("div", { className: "bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3 flex items-center gap-2" },
                    React.createElement(AlertCircle, { size: 20, className: "text-yellow-400 flex-shrink-0" }),
                    React.createElement("span", { className: "text-sm text-yellow-200" },
                        React.createElement("strong", null, "Prioridade Sugerida:"),
                        " ",
                        suggestedPriority)),
                React.createElement("div", { className: "flex gap-3 pt-2" },
                    React.createElement("button", { type: "button", onClick: onClose, className: "flex-1 bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded-lg font-semibold transition", disabled: loading }, "Cancelar"),
                    React.createElement("button", { type: "submit", disabled: loading || !title.trim() || !description.trim(), className: "flex-1 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 disabled:from-gray-600 disabled:to-gray-600 disabled:cursor-not-allowed text-white py-3 px-6 rounded-lg font-semibold transition flex items-center justify-center gap-2" }, loading ? (React.createElement(React.Fragment, null,
                        React.createElement(Loader2, { size: 20, className: "animate-spin" }),
                        "Enviando...")) : (React.createElement(React.Fragment, null,
                        React.createElement(CheckCircle, { size: 20 }),
                        "Enviar Feedback")))))),
        React.createElement("style", null, "\n                @keyframes fadeIn {\n                    from { opacity: 0; }\n                    to { opacity: 1; }\n                }\n                @keyframes slideUp {\n                    from { transform: translateY(20px); opacity: 0; }\n                    to { transform: translateY(0); opacity: 1; }\n                }\n                .animate-fadeIn {\n                    animation: fadeIn 0.2s ease-out;\n                }\n                .animate-slideUp {\n                    animation: slideUp 0.3s ease-out;\n                }\n            ")), document.body);
};
export default FeedbackModal;
